<div id="wrapper">
  <div class="innerdiv">
    <topnavbar></topnavbar>
    <nav class="navbar-default navbar-static-side" role="navigation">
      <div class="sidebar-collapse">
        <ul class="nav metismenu" id="side-menu">
          <li>
            <a routerLink="./home">
              <p class="dropdown profile-element">
                <em class="glyphicon glyphicon-tasks	"></em>Dashboard
              </p>
            </a>
          </li>
          <li *ngFor="let item of finalFun">
            <a>
              <p class="dropdown profile-element">
                <em class="glyphicon glyphicon-tasks	"></em> {{ item.parent_name }}
              </p>
              <p class="logo-element" style="font-size: 10px">
                <em class="glyphicon glyphicon-tasks	"></em>{{ item.parent_name }}
              </p>

              <span class="arrow"></span>
            </a>

            <ul class="collapse nav metismenu" id="{{ item.ref_name }}">
              <li *ngFor="let child of item.child">
                <a routerLink="{{ child.FUN_ROUTER_NAME }}" (click)="selectFunction(child.FUN_ID)">
                  <em class="fa fa-car" style="font-size:10px;color:red;"> </em>
                  <span class="nav-label"> {{ child.FUN_NAME }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <div id="page-wrapper" class="gray-bg">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>